import { ExpandMore } from "@mui/icons-material";
import { 
    Accordion as MuiAccordion, 
    AccordionDetails as MuiAccordionDetails, 
    AccordionSummary as MuiAccordionSummary } from "@mui/material";
import { withStyles } from "@mui/styles";
import { fontWeight } from "@mui/system";
import { useState } from "react";
import { useForm } from "react-hook-form";

const Accordion = withStyles({

})(MuiAccordion);

const AccordionDetails = withStyles({

})(MuiAccordionDetails);

const AccordionSummary = withStyles({

})(MuiAccordionSummary);

const Acordeao = () => {
    const [expandedPanel, setExpandedPanel] = useState(false);
    const { register, handleSubmit, formState: { errors } } = useForm();

    const handleAccordionChange = (panel) => (event, isExpanded) => {
        setExpandedPanel(isExpanded ? panel : false);
    }

    const sabemito = handleSubmit (async (data) => {
        console.log(data);
    })

    return (
        <div style={{ width: "600px" }}>
            <form onSubmit={sabemito}>
            <Accordion expanded={expandedPanel === 'panel1'} onChange={handleAccordionChange('panel1')}>
                <AccordionSummary 
                    expandIcon={<ExpandMore style={{ color: "white" }} />} 
                    sx={{ 
                        background : "transparent linear-gradient(180deg, #7C4AE2 0%, #513CDC 100%) 0% 0% no-repeat padding-box;",
                        color: "whitesmoke",
                        fontWeight: "bold"
                    }} >
                    Interessado
                </AccordionSummary>
                <AccordionDetails>
                    teste
                    <input type="text" name="texto" {...register("texto")} />
                </AccordionDetails>
            </Accordion>
            <Accordion expanded={expandedPanel === 'panel2'} onChange={handleAccordionChange('panel2')}>
                <AccordionSummary expandIcon={<ExpandMore />} >
                    Localização
                </AccordionSummary>
                <AccordionDetails>
                <input type="text" name="testin" {...register("testin")} />
                </AccordionDetails>
            </Accordion>
            <Accordion expanded={expandedPanel === 'panel3'} onChange={handleAccordionChange('panel3')}>
                <AccordionSummary expandIcon={<ExpandMore />} >
                    Geração
                </AccordionSummary>
                <AccordionDetails>
                    <input type="text" name="davi" {...register("davi")} />
                </AccordionDetails>
            </Accordion>
            <button type="submit">testa</button>
            </form>
        </div>
    )
}

export { Acordeao }